import { FeatureFlagsProvider } from './FeatureFlagsProvider';

const name = 'FeatureFlagsProvider';

export { name, FeatureFlagsProvider };
export { JobsiteFeatureFlagsProvider } from './JobsiteFeatureFlagsProvider';
export { useFlags, type FeatureFlags } from './helpers/useFlags';
